import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {TRANSLATE} from '../../classes/translatable';
import {Batiment} from '../../../infrastructure/shared/classes/batiment';
import {debounceTime, filter} from 'rxjs/operators';
import {InfrastructureService} from '../../../infrastructure/shared/services/infrastructure.service';
import { Role } from '../../../identite/shared/classes/role';
import { AuthenticationService } from '../../../core/services/authentication.service';
import { SearchFilter } from '../../classes/search-filter';
import { b } from '@angular/core/src/render3';
import { Mode } from '../../../core/shared/enum/mode';

@Component({
  selector: 'app-search-batiment',
  templateUrl: './search-batiment.component.html',
  styleUrls: ['./search-batiment.component.css']
})
export class SearchBatimentComponent implements OnInit {
  @Input()  _formControl: FormControl;
  @Input()  _projetFormControl: FormControl;
  @Input()  label = TRANSLATE("Bâtiment");
  @Input()  isLocked = false;
  @Input()  unsetTooltip = TRANSLATE('Associer un autre bâtiment');
  @Input()  isDeleteAble = true;
  @Input()  mode: Mode = Mode.PROMOTION;
  @Input()  id: string = null;

  @Output() selectBatiment = new EventEmitter<Batiment>();

  public lstBtm: Batiment[] = [];
  public lstBatiments: any[];
  public maitre: Role;
  public batiment: Batiment;
  formFilters: any;
  btmIdFilter: SearchFilter;
  maitreIdFilter: SearchFilter;
  hidden = false;
  projet: string = null;

  doSomething(selectedMaitre: Role) {

    if(selectedMaitre ){
      this.maitre = selectedMaitre;
      this.hidden = false;
      this.getBatiments();
    }
  }
  constructor(private infraService: InfrastructureService,
    private authenticationService: AuthenticationService) { }

  ngOnInit() {
    
    this.maitre   = JSON.parse(localStorage.getItem('maitreOuvrage'));
    this.batiment   = JSON.parse(localStorage.getItem('batiment'));

    this.formFilters = null;
    this.authenticationService.maitreEvent.subscribe(maitre => {
      this.maitre = maitre;
      this.getBatiments();
    });

    this.authenticationService.batimentEvent.subscribe(batiment => {
      this.batiment = batiment;
      this.getBatiments();
    });
    if(this._formControl.value){
      this.batiment = this._formControl.value;
    }
    if (this._projetFormControl && this._projetFormControl.value){
      this.projet = this._projetFormControl.value;
    }
    this.getBatiments();
  }

  optionSelected(batiment: string) {
    const batSelected = this.lstBatiments.find(elem => elem.id === batiment);
    this._formControl.setValue(batSelected);
    this.selectBatiment.emit(batSelected);
    this.isLocked = true;
  }

  initSearchBatiment() {
    this._formControl.valueChanges
        .pipe(
            debounceTime(400),
            filter((value: string) => value && value.length > 2)
        )
        .subscribe(data => {
          this.lstBtm = [];
          this.lstBatiments.forEach(element => {
            if (element.ref.toUpperCase().indexOf(data.toUpperCase()) > -1) {
              this.lstBtm.push(element);
            } else if (element.libelle_projet && element.libelle_projet.toUpperCase().indexOf(data.toUpperCase()) > -1) {
              this.lstBtm.push(element);
            }
          });
        });
  }

  getBatiments() {
    this.formFilters = [];

    if(this.batiment && this.batiment.id && this.batiment.id != '0' ){
        this.btmIdFilter = new SearchFilter({key: 'batiment_id', compare: '=', value:this.batiment.id});
        this.formFilters.push(this.btmIdFilter);
    }


    if(this.maitre && this.maitre.id && this.maitre.id != '0' ){
      if(this.maitre.acl_roles_id == "maitre_ouvrage"){
        this.maitreIdFilter = new SearchFilter({key: 'maitre_id', compare: '=', value:this.maitre.id});
        this.formFilters.push(this.maitreIdFilter);
      } else {
        this.maitreIdFilter = new SearchFilter({key: 'agence_bureaux_id', compare: '=', value:this.maitre.id});
        this.formFilters.push(this.maitreIdFilter);
        
      }
    }

    this.infraService.getBatimentsListFiltered(null, null, this.formFilters)
        .subscribe(retour => {
          if (retour.status === 200) {
            this.lstBatiments = retour.data;
           // this.initSearchBatiment();
          }
        });
    }

  unsetBatiment() {
    if (!this.isDeleteAble)
      return;
    this.isLocked = false;
    this._formControl.setValue('');
  }
}
